Namespace 'AccountSettings.Topics'

class AccountSettings.Topics.TopicsCheckboxView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/topics_checkbox"]

  events:
    "click .topics-check": "onTopicsCheck"

  initialize: (options) ->
    @checkName = options.name
    @checkText = options.text
    @visible = options.visible
    @enabled = options.enabled
    @tooltip = options.tooltip
    @afterCheckCallback = options.callback
    @afterCheckCallback(@enabled) if @afterCheckCallback
    super

  render: =>
    @$el.html(@template(
        visible: @visible,
        enabled: @enabled,
        checkName: @checkName,
        checkText: @checkText,
        tooltip: @tooltip
      )
    )
    @delegateEvents()
    @

  onTopicsCheck: =>
    @setCheckState(!@enabled)
    @render()
    @afterCheckCallback(@enabled) if @afterCheckCallback

  setCheckState: (state) =>
    @enabled = state
    @render()

  disable: =>
    @$el.addClass('disabled')

  enable: =>
    @$el.removeClass('disabled')

  getCheckState: =>
    @enabled

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')
